// External Imports
import { MdClose, MdInfo } from "react-icons/md";
import Modal from "./Modal";

// Internal Imports

/** ========================================================================
 * * ResponseModal Component
 * This component renders a modal that displays a response.
 * ========================================================================== */

export default function ResponseModal({ open, setOpen, response }) {
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="p-6 modal max-w-[600px]">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 text-green-600">
            <MdInfo className="w-5 h-5" />
            <p className="text-lg font-semibold">Response</p>
          </div>
          <MdClose onClick={() => setOpen(false)} className="icon" />
        </div>
        <textarea className="font-semibold form-input" rows={5} value={response} />
      </div>
    </Modal>
  );
}
